export const LOGOS = {
  NANDOS:
    'https://ilxpksvqekjhagluhfzb.supabase.co/storage/v1/object/public/images/app/nandos-01.png?v=4',
  MOTHERLAND:
    'https://ilxpksvqekjhagluhfzb.supabase.co/storage/v1/object/public/images/app/motherland-coffee-logo.png?v=4',
  SEATTLE:
    'https://ilxpksvqekjhagluhfzb.supabase.co/storage/v1/object/public/images/app/seattle-coffee-logo.png?v=4',
  PHIC: 'https://ilxpksvqekjhagluhfzb.supabase.co/storage/v1/object/public/images/app/Pauls-Homemade-Ice-Cream.webp?v=4',
  TS_AFRICA:
    'https://ilxpksvqekjhagluhfzb.supabase.co/storage/v1/object/public/images/app/TSAFRIKA%20logo-01.png?v=4',
  SPIER:
    'https://ilxpksvqekjhagluhfzb.supabase.co/storage/v1/object/public/images/app/18E8D2D5.jpeg?v=4',
}

export const PAYMENT_METHODS = {
  KIOSK: 'Kiosk',
  DEBIT_CARD: 'Debit Card',
  CONCIERGE_DESK: 'Digital Concierge Desk',
  PAYROLL: 'Payroll',
}

export const LOCATION_OPTIONS = {
  CAMPUS: 'Campus',
  HOME: 'Home',
}

export const USER_TYPES = {
  USER: 'user',
  VENDOR: 'vendor',
  SERVICE_PROVIDER: 'service_provider',
}

export const SHIPPING_COST = 250
